<div *ngIf="userId && verifyMethod">
  <dx-verify [userID]="userId" [method]="verifyMethod" (success)="receivedDataHandler($event)" [allowCloseableModal]="true" [isPrimaryApplicant]="isPrimaryApplicant" [isYouthMembership]="isYouthMembership"></dx-verify>
</div>
